export default "__VITE_ASSET__DV9xQzL___"